import { Divider, Form, Input } from 'antd'
import { tabFields } from '~app/configuration/labels'
import type { AutoFocusedFields } from '~app/hooks/useField'
import i18n from '~app/i18n/i18n'

interface Props {
  natifMetadataFields: AutoFocusedFields<{ scanId: string; date: string }>
}

const NatifMetadata = ({ natifMetadataFields }: Props) => {
  return (
    <>
      <Divider
        orientation="left"
        orientationMargin={0}
        style={{ margin: '8px 0' }}
      >
        {i18n.t('documentView.natifMetadata.title')}
      </Divider>
      <Form.Item
        label={i18n.t('documentView.natifMetadata.scanId.title')}
        style={{ marginBottom: 8 }}
      >
        <Input
          {...natifMetadataFields.scanId.inputField}
          placeholder={i18n.t('documentView.natifMetadata.scanId.placeholder')}
          tabIndex={tabFields.natifMetadata}
        />
      </Form.Item>
      <Form.Item
        label={i18n.t('documentView.natifMetadata.date.title')}
        style={{ marginBottom: 8 }}
      >
        <Input
          {...natifMetadataFields.date.inputField}
          placeholder={i18n.t('documentView.natifMetadata.date.placeholder')}
          tabIndex={tabFields.natifMetadata}
        />
      </Form.Item>
    </>
  )
}

export default NatifMetadata
